import {Pipe, PipeTransform} from '@angular/core';

import {GPTranslateService} from '../localization/translate.service';

import {ContractAlert} from './contract-alerts.model';

@Pipe({
  name: 'filterAlerts',
  pure: true
})
export class FilterAlertsPipe implements PipeTransform {

  constructor(private translate: GPTranslateService) {
  }

  transform(alerts: ContractAlert[], searchValue: string, languageChanged): ContractAlert[] {

    if (!searchValue) {
      return alerts;
    }

    return alerts.filter((alert) =>
      alert.zones && alert.zones.some(zone =>
        this.translate.getDisplayTranslation(zone.transIds).toLowerCase().indexOf(searchValue.toLowerCase()) > -1));
  }
}
